var LocationStatus;
(function (LocationStatus) {
    LocationStatus["NONE"] = "NONE";
    LocationStatus["EXPIRED"] = "EXPIRED";
    LocationStatus["RECENT"] = "RECENT";
})(LocationStatus || (LocationStatus = {}));
export default LocationStatus;
